import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions } from '@mui/material';

import Modal from 'src/components/common/Modal';

export interface FollowUpDeleteModalProps {
  showModal: boolean;
  onClose: () => void;
  handleConfirmDelete: () => void;
}

const FollowUpDeleteModal: FC<FollowUpDeleteModalProps> = ({
  showModal,
  handleConfirmDelete,
  onClose,
}) => {
  const { t } = useTranslation(['myFollowUp', 'common']);

  return (
    <Modal
      headline={t('myFollowUp:delete')}
      message={t('myFollowUp:deleteWarning')}
      isOpen={showModal}
      onClose={onClose}
    >
      <DialogActions>
        <Button variant="cta" color="secondary" fullWidth onClick={onClose}>
          {t('common:cancel')}
        </Button>

        <Button
          variant="cta"
          fullWidth
          onClick={() => {
            handleConfirmDelete();
            onClose();
          }}
        >
          {t('common:confirm')}
        </Button>
      </DialogActions>
    </Modal>
  );
};

export default FollowUpDeleteModal;
